import { useEffect, useRef, useCallback, useState } from 'react';
import { Vector, Face } from 'kalidokit';
import GetAudioLevel from './GetAudioLevel';

export default function Live2dDetectVoiceOther({ modelRef, id }) {
  const intervalRef = useRef(null);
  const [otherAudioLevel, setOtherAudioLevel] = useState(0); //音声レベル
  const mouthActionRef = useRef(null);
  const mouthTargetValueRef = useRef(0);
  const mouthCurrentValueRef = useRef(0);
  const mouthDirectionRef = useRef('up');
  const mouthTargetValueRef2 = useRef(0);
  const mouthCurrentValueRef2 = useRef(0);
  const mouthDirectionRef2 = useRef('up');
  const blinkIntervalRef = useRef(null);
  const blinkActionRef = useRef(null);
  const blinkValueRef = useRef(1);
  const blinkStateRef = useRef('closing');

  useEffect(() => {
    //アイドルモーションの設定
    setIdleMotion();

    //まばたきのタイミング
    blinkIntervalRef.current = setInterval(() => {
      //一度クリア
      if (blinkActionRef.current != null) {
        clearInterval(blinkActionRef.current);
      }

      //ランダム数を生成
      const min = 1000; // 最小値を指定
      const max = 3000; // 最大値を指定

      let random = Math.floor(Math.random() * (max + 1 - min)) + min;
      setTimeout(startBlink(), random);
    }, 4000);

    //口開閉のインターバル開始
    intervalRef.current = setInterval(() => {
      //音量レベルを取得
      GetAudioLevel(id)
        .then((value) => {
          //   console.log(value);
          setOtherAudioLevel(value);
        })
        .catch((e) => {});
    }, 100);

    return () => {
      clearInterval(intervalRef.current);
      clearInterval(blinkActionRef.current);
      clearInterval(blinkIntervalRef.current);
      clearInterval(mouthActionRef.current);

      blinkValueRef.current = 1;
      blinkStateRef.current = 'closing';
      mouthCurrentValueRef.current = 0;
      mouthCurrentValueRef2.current = 0;
    };
  }, []);

  //ディフォルトのアイドルモーションを設定
  function setIdleMotion() {
    //モデルがロードされていない場合
    if (modelRef.current == null) {
      //１秒後に再度確認
      setTimeout(() => {
        setIdleMotion();
      }, 1000);

      return;
    }

    //モーションをアクティングモードに変更
    modelRef.current.internalModel.motionManager.groups.idle = 'Acting';
  }

  //まばたきかいし
  function startBlink() {
    blinkActionRef.current = setInterval(() => {
      if (blinkStateRef.current == 'closing') {
        blinkValueRef.current -= 0.1;
      }

      if (blinkStateRef.current == 'opening') {
        blinkValueRef.current += 0.1;
      }

      if (blinkValueRef.current <= 0 && blinkStateRef.current == 'closing') {
        blinkStateRef.current = 'opening';
        //blinkValueRef.current = 0;
      }

      if (blinkValueRef.current >= 1 && blinkStateRef.current == 'opening') {
        clearInterval(blinkActionRef.current);
        blinkActionRef.current = null;
        //ディフォルトに戻す
        blinkStateRef.current = 'closing';
        blinkValueRef.current = 1;
      }

      //コアモデルへの参照用
      if (modelRef.current != null) {
        const coreModel = modelRef.current.internalModel.coreModel;

        //アップデート
        // modelRef.current.internalModel.motionManager.update = (...args) => {
        // eye blink
        coreModel.setParameterValueById('ParamEyeLOpen', blinkValueRef.current);
        coreModel.setParameterValueById('ParamEyeROpen', blinkValueRef.current);
      }

      // };
    }, 20);
  }

  //マウスのオープン
  function startMouth() {
    //前回のインターバルをクリア
    if (mouthActionRef.current != null) {
      clearInterval(mouthActionRef.current);
      mouthActionRef.current = null;
    }

    //動作方向
    if (mouthTargetValueRef.current >= mouthCurrentValueRef.current) {
      mouthDirectionRef.current = 'up';
    } else {
      mouthDirectionRef.current = 'down';
    }

    if (mouthTargetValueRef2.current >= mouthCurrentValueRef2.current) {
      mouthDirectionRef2.current = 'up';
    } else {
      mouthDirectionRef2.current = 'down';
    }

    //マウス動作
    mouthActionRef.current = setInterval(() => {
      let addValue = 0.2;

      //口の開閉
      if (mouthDirectionRef.current == 'up') {
        //0.1ずつ上げていく
        mouthCurrentValueRef.current += addValue;

        //ターゲットに到達したらそれ以上はいかない
        if (mouthCurrentValueRef.current >= mouthTargetValueRef.current) {
          mouthCurrentValueRef.current = mouthTargetValueRef.current;
        }
      } else {
        //0.1ずつ下げていく
        mouthCurrentValueRef.current -= addValue;
        if (mouthCurrentValueRef.current <= mouthTargetValueRef.current) {
          mouthCurrentValueRef.current = mouthTargetValueRef.current;
        }
      }

      //口の横
      if (mouthDirectionRef2.current == 'up') {
        //0.1ずつ上げていく
        mouthCurrentValueRef2.current += addValue;

        //ターゲットに到達したらそれ以上はいかない
        if (mouthCurrentValueRef2.current >= mouthTargetValueRef2.current) {
          mouthCurrentValueRef2.current = mouthTargetValueRef2.current;
        }
      } else {
        //0.1ずつ下げていく
        mouthCurrentValueRef2.current -= addValue;
        if (mouthCurrentValueRef2.current <= mouthTargetValueRef2.current) {
          mouthCurrentValueRef2.current = mouthTargetValueRef2.current;
        }
      }

      //口を変形する
      const coreModel = modelRef.current.internalModel.coreModel;

      coreModel.setParameterValueById('ParamMouthOpenY', mouthCurrentValueRef.current);
      coreModel.setParameterValueById('ParamMouthForm', mouthCurrentValueRef2.current);

      // modelRef.current.internalModel.motionManager.update = (...args) => {
      //   coreModel.setParameterValueById('ParamMouthOpenY', mouthCurrentValueRef.current);
      //   coreModel.setParameterValueById('ParamMouthForm', mouthCurrentValueRef2.current);
      // };

      //インターバルを終了
      if (mouthCurrentValueRef.current == mouthTargetValueRef.current) {
        clearInterval(mouthActionRef.current);
        mouthActionRef.current = null;
      }
    }, 30);
  }

  useEffect(() => {
    if (modelRef.current == null) return;

    var random = Math.random(); // 0~1のランダム
    var plusOrMinus = Math.random() < 0.5 ? -1 : 1; // 1か-1の２つのどちらか

    //自動的にまばたきをするかどうかの設定
    modelRef.current.internalModel.eyeBlink = undefined;

    if (otherAudioLevel < 0.1) {
      random = 0;
    }

    //直前と値が一緒の場合は何もしない
    if (random != mouthTargetValueRef.current) {
      //ターゲット値を入れる
      mouthTargetValueRef.current = random;
      mouthTargetValueRef2.current = random * plusOrMinus;

      //マウス動作開始
      startMouth();
    }
  }, [otherAudioLevel]);

  return false;
}
